// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__20L_0","modalFooterButton":"ModalNotes_modalFooterButton__1WU5o"};